import React from 'react';
import User from '../../Services/UserService/User';

export type PasswordResetData = {
	needsPasswordReset: boolean;
	forcePasswordReset: boolean;
	daysBeforePasswordExpiration: number | undefined;
};

export type LoginContextType = {
	isLoggedIn: boolean;
	userInfo?: User;
	error?: string;
	setError: (error: string | undefined) => void;
	performLogin(
		userName: string,
		password: string,
		otp: string,
		branch: string,
		redirectDestination?: string,
	): void;
	performLogout(): void;
	passwordResetData?: PasswordResetData;
	skipResetPassword(): void;
	supportUrl?: string;
};

export const passwordResetInitialValue: PasswordResetData = {
	needsPasswordReset: false,
	forcePasswordReset: false,
	daysBeforePasswordExpiration: undefined,
};

const initialValue: LoginContextType = {
	isLoggedIn: false,
	performLogin: () => undefined,
	performLogout: () => undefined,
	passwordResetData: passwordResetInitialValue,
	skipResetPassword: () => undefined,
	setError: () => undefined,
};

const LoginContext = React.createContext<LoginContextType>(initialValue);

export default LoginContext;
